<template>
  <v-navigation-drawer
    v-model="drawer"
    location="left"
    class="rounded-xl px-5 py-10 flyout"
    temporary
  >
    <v-btn
      flat
      icon="menu_open"
      size="48"
      @click.stop="drawer = false"
    />
    <nav 
      class="d-flex flex-column ga-2 my-8 align-start"
    >
      <v-btn
        flat
        size="x-large"
        class="rounded-xl text-capitalize"
        :to="$routeTo(ROUTES.CALENDAR)"
        :class="{'bg-primary text-on-primary': $route.name === ROUTES.CALENDAR || $route.name.startsWith('event')}"
        prepend-icon="calendar_month"
      >
        <span class="text-size-minus-1">Calendar</span>
      </v-btn>
      <v-btn
        flat
        size="x-large"
        class="rounded-xl text-capitalize"
        :to="$routeTo(ROUTES.TODOS)"
        :class="{'bg-primary text-on-primary': $route.name.startsWith(ROUTES.TODOS)}"
        prepend-icon="checklist"
      >
        <span class="text-size-minus-1">Lists</span>
      </v-btn>
      <v-btn
        flat
        size="x-large"
        class="rounded-xl text-capitalize"
        :to="$routeTo(ROUTES.ANNOTATIONS)"
        :class="{'bg-primary text-on-primary': $route.name === ROUTES.ANNOTATIONS}"
        prepend-icon="draw"
        v-if="$vuetify.display.mdAndUp"
      >
        <span class="text-size-minus-1">Notes</span>
      </v-btn>
      <v-btn
        flat
        size="x-large"
        class="rounded-xl text-capitalize"
        :to="$routeTo(ROUTES.SETTINGS)"
        :class="{'bg-primary text-on-primary': $route.name === ROUTES.SETTINGS}"
        prepend-icon="settings"
      >
        <span class="text-size-minus-1">Settings</span>
      </v-btn>
    </nav>
  </v-navigation-drawer>

  <v-btn
    flat
    icon="menu"
    size="48"
    @click.stop="drawer = !drawer"
  />
</template>

<script lang="ts">
import {defineComponent, ref, watch} from 'vue'

const drawer = ref(false),
      group = ref(null)

watch(group, () => {
  drawer.value = false
})

export default defineComponent({
  name: 'AppNav',
  setup() {
    return {
      drawer,
      group,
    }
  }
})
</script>
<style lang="scss" scoped>
.flyout {
  bottom: 1rem !important;
  height: calc(100vh - 2rem) !important;
  left: 1rem !important;
  top: 1rem !important;
  transform: translateX(-17rem) !important;
  width: 16rem;
}

.v-navigation-drawer--active {
  transform: translateX(0) !important;
}

.v-navigation-drawer__scrim {
  position: fixed;
}
</style>